import React from 'react';

import CacheComponent from './CacheComponent';
import CheckpointComponent from './CheckpointComponent';
import ConflictComponent from './ConflictComponent';
import CrashComponent from './CrashComponent';
import CriminalComponent from './CriminalComponent';
import EngagementComponent from './EngagementComponent';
import HazardComponent from './HazardComponent';
import IedComponent from './IedComponent';
import IllegalParkingComponent from './IllegalParkingComponent';
import ObservationComponent from './ObservationComponent';
import PublicDisruption from './PublicDisruption';
import SabotageComponent from './SabotageComponent';
import SurveillanceComponent from './SurveillanceComponent';
import ThreatComponent from './ThreatComponent';
import UasComponent from './UasComponent';

export default (report, beta = true) =>
  ({
    cache: <CacheComponent report={report} beta={beta} />,
    checkpoint: <CheckpointComponent report={report} beta={beta} />,
    conflict: <ConflictComponent report={report} beta={beta} />,
    crash: <CrashComponent report={report} beta={beta} />,
    criminal: <CriminalComponent report={report} beta={beta} />,
    engagement: <EngagementComponent report={report} beta={beta} />,
    hazard: <HazardComponent report={report} beta={beta} />,
    ied: <IedComponent report={report} beta={beta} />,
    illegal_parking: <IllegalParkingComponent report={report} beta={beta} />,
    observation: <ObservationComponent report={report} beta={beta} />,
    public_disruption: <PublicDisruption report={report} beta={beta} />,
    sabotage: <SabotageComponent report={report} beta={beta} />,
    surveillance: <SurveillanceComponent report={report} beta={beta} />,
    threat: <ThreatComponent report={report} beta={beta} />,
    uas: <UasComponent report={report} beta={beta} />,
  })[report.type];
